export default __webpack_public_path__ + "static/media/ic_info.1a6ddc6e.svg";